import { AUTH_ORG_QUERY_PARAM_NAME } from '../auth/authConsts';
import { useRunOnceWhenTruthy } from '../components/common/useRunOnceWhenTruthy';
import useQueryParams from '../navigation-utils/useQueryParams';
import useSweepNavigate from '../navigation-utils/useSweepNavigate';
import useUserInfo from './useUserInfo';

export const useRemoveAuthOrgQueryParamFromUrl = () => {
  const queryParams = useQueryParams();
  const authOrgId = queryParams.get(AUTH_ORG_QUERY_PARAM_NAME);
  const fullName = queryParams.get('fullName');
  const { removeQueryParams } = useSweepNavigate();
  const { updateUserInfo } = useUserInfo();

  useRunOnceWhenTruthy(() => {
    if (authOrgId) {
      removeQueryParams([AUTH_ORG_QUERY_PARAM_NAME]);
    }
  }, !!authOrgId);

  useRunOnceWhenTruthy(() => {
    if (fullName) {
      updateUserInfo({ name: fullName });
      removeQueryParams(['fullName']);
    }
  }, !!fullName);
};
